import axios from 'axios';

export default {
	getPretradeData() {
		return axios.get('/apps/pretrade/records');
	},
	getPretradeDataById(id) {
		return axios.get(`/apps/pretrade/records/${id}`);
	},
	getPretradeDataByDates(model) {
		return axios.get(`/apps/pretrade/records/${model.startDate}/${model.endDate}`);
	},
	getPretradeCsvById(id) {
		return axios.get(`/apps/pretrade/records/csv/${id}`);
	},
	getPretradeCsvByDates(model) {
		return axios.get(`/apps/pretrade/records/csv/${model.startDate}/${model.endDate}`);
	}
};
